module.exports = __webpack_public_path__ + "img/AndreSobottka_140x140_rund.51515cf5.jpg";